import { Helpers } from '../../helpers';
import { IResourceCategory } from '../../interfaces/iresource-category';
import { Item } from '../item';
import { ItemCategory } from '../item-category';
import { ProjectResourceCalculationsAssignment } from '../project-resource-calculations-assignment';
import { ResourceCalculation } from '../resource-calculation';
import { ScheduleActivityResourceCategory } from '../schedule-activity-resource-category';
import { StandardConfigurationDetail } from '../standard-configuration-detail';

export class ResourceCategoryBase {
  ResourceCategoryId: number;
  ResourceCategoryName: string | null;
  ItemId: number | null;
  ItemCategoryId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectResourceCalculationsAssignments_ResourceCategory?: Array<ProjectResourceCalculationsAssignment> | null;
  ResourceCalculations_ResourceCategory?: Array<ResourceCalculation> | null;
  ScheduleActivityResourceCategories_ResourceCategory?: Array<ScheduleActivityResourceCategory> | null;
  StandardConfigurationDetails_ResourceCategory?: Array<StandardConfigurationDetail> | null;
  ItemCategory?: ItemCategory;
  Item?: Item;

  constructor(item?: IResourceCategory) {
    if (item) {

      this.ResourceCategoryId = item.ResourceCategoryId;
      this.ResourceCategoryName = item.ResourceCategoryName;
      this.ItemId = item.ItemId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectResourceCalculationsAssignments_ResourceCategory = Helpers.createClassArray(ProjectResourceCalculationsAssignment, item.ProjectResourceCalculationsAssignments_ResourceCategory);
      this.ResourceCalculations_ResourceCategory = Helpers.createClassArray(ResourceCalculation, item.ResourceCalculations_ResourceCategory);
      this.ScheduleActivityResourceCategories_ResourceCategory = Helpers.createClassArray(ScheduleActivityResourceCategory, item.ScheduleActivityResourceCategories_ResourceCategory);
      this.StandardConfigurationDetails_ResourceCategory = Helpers.createClassArray(StandardConfigurationDetail, item.StandardConfigurationDetails_ResourceCategory);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.Item = new Item(item.Item);
    }
  }
}